import React from 'react';
import InspectorRow from '../shared/inspector-row';
import InspectorSection from '../shared/inspector-section';
import NumberField from '../shared/number-field';
import { useFabricProp } from '../shared/use-fabric-prop';
import type { ObjectInspectorProps } from '../types';

const TransformSection: React.FC<ObjectInspectorProps> = ({ object, editor }) => {
  const [left, setLeft] = useFabricProp<number>(object, 'left', editor);
  const [top, setTop] = useFabricProp<number>(object, 'top', editor);
  const [width, setWidth] = useFabricProp<number>(object, 'width', editor);
  const [height, setHeight] = useFabricProp<number>(object, 'height', editor);
  const [angle, setAngle] = useFabricProp<number>(object, 'angle', editor);

  return (
    <InspectorSection title="Transform">
      <InspectorRow label="X">
        <NumberField value={left} onChange={setLeft} />
      </InspectorRow>
      <InspectorRow label="Y">
        <NumberField value={top} onChange={setTop} />
      </InspectorRow>
      <InspectorRow label="Width">
        <NumberField value={width} onChange={setWidth} min={1} />
      </InspectorRow>
      <InspectorRow label="Height">
        <NumberField value={height} onChange={setHeight} min={1} />
      </InspectorRow>
      <InspectorRow label="Angle">
        <NumberField value={angle} onChange={setAngle} step={1} />
      </InspectorRow>
    </InspectorSection>
  );
};

export default TransformSection;
